<form [formGroup]="sessionForm" (ngSubmit)="onSubmit()">

  <mat-form-field appearance="outline" class="label">
    <mat-label>Date / Identification</mat-label>
    <input matInput type="text" formControlName="label">
  </mat-form-field>

  <div class="date">
    <mat-form-field appearance="outline" class="label">
      <mat-label>Date de début </mat-label>
      <input matInput [matDatepicker]="pickerStart" [min]="today" formControlName="startDate" (focus)="pickerStart.open()">
      <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
      <mat-datepicker #pickerStart></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>heure</mat-label>
      <input matInput type="time" formControlName="startHour">
    </mat-form-field>
  </div>

  <div class="date">
    <mat-form-field appearance="outline">
      <mat-label>Date de fin</mat-label>
      <input matInput [matDatepicker]="pickerEnd" [min]="f.startDate.value" formControlName="endDate" (focus)="pickerEnd.open()">
      <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
      <mat-datepicker #pickerEnd></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>heure </mat-label>
      <input matInput type="time" formControlName="endHour">
    </mat-form-field>
  </div>

  <div class="participant_confirm">
    <mat-form-field appearance="outline">
      <mat-label>Nombre max. de participants </mat-label>
      <input matInput type="number" formControlName="quantity">
    </mat-form-field>

    <button type="submit" appChangeColorTheme attribute="bgc">Ajouter</button>
  </div>

</form>
